var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.$ct("title")) + " ")]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c("app-custom-table", [
            _c("thead", [_c("tr", [_c("th", [_vm._v("Tape")])])]),
            _c(
              "tbody",
              _vm._l(_vm.results, function (result, index) {
                return _c(
                  "tr",
                  {
                    key: index,
                    class: { selected: result == _vm.selectedFormula },
                    on: {
                      click: function ($event) {
                        _vm.selectedFormula = result
                      },
                    },
                  },
                  [
                    _c("td", [
                      _vm._v(
                        _vm._s(result.formula) +
                          " = " +
                          _vm._s(result.result.toFixed(2))
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _c("w-input", {
            staticClass: "mt",
            attrs: { autofocus: true },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.validateFormula.apply(null, arguments)
              },
            },
            model: {
              value: _vm.currentFormula,
              callback: function ($$v) {
                _vm.currentFormula = $$v
              },
              expression: "currentFormula",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$ct("common.cancel"))),
          ]),
          _c("w-spacer"),
          _c("w-button", { on: { click: _vm.add } }, [
            _vm._v(_vm._s(_vm.$ct("add"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }